// extracted by mini-css-extract-plugin
export var closeButton = "plAFb";
export var drawerBody = "f3o6J";
export var drawerContainer = "_sc79";
export var drawerContainerInResize = "kQF6e";
export var drawerContainerPopout = "iJCbZ";
export var drawerHeader = "VTncA";
export var fullBleed = "Gbygh";
export var hiddenContent = "sL7LF";
export var noPaddingBody = "cD85G";
export var resizeSpacer = "D_jfc";
export var resizeWrapper = "xU5WZ";
export var resizeWrapperPopout = "EEYMc";